import { createTheme } from "@mui/material/styles";

const SIDEBAR_BG = "#0F1F14";
const PRIMARY = "#2D6A4F";
const PRIMARY_DARK = "#1B4332";
const PRIMARY_LIGHT = "#52B788";
const SECONDARY = "#9C6B2E";
const BG_DEFAULT = "#F2EFE9";

export const theme = createTheme({
  palette: {
    primary: {
      main: PRIMARY,
      dark: PRIMARY_DARK,
      light: PRIMARY_LIGHT,
      contrastText: "#FFFFFF"
    },
    secondary: {
      main: SECONDARY,
      contrastText: "#FFFFFF"
    },
    background: {
      default: BG_DEFAULT,
      paper: "#FFFFFF"
    },
    success: { main: "#2E7D32" },
    warning: { main: "#E65100" },
    error: { main: "#C62828" }
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 }
  },
  shape: { borderRadius: 10 },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#1A2B1E",
          boxShadow: "0 1px 3px rgba(0,0,0,.08)"
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 2px 12px rgba(0,0,0,.07)",
          border: "1px solid rgba(0,0,0,.06)"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        // Bottoni più ALTI (più visibili) senza allargarli: alziamo solo il padding
        // verticale e una minHeight per misura. La larghezza resta invariata.
        root: { textTransform: "none", fontWeight: 600, borderRadius: 8 },
        // small e medium alla STESSA altezza, così le toolbar miste
        // (es. "Stampa"/"Esporta PDF" small accanto a "Nuovo socio" medium)
        // risultano uniformi e ben visibili.
        sizeSmall: { minHeight: 46, paddingTop: 9, paddingBottom: 9 },
        sizeMedium: { minHeight: 46, paddingTop: 9, paddingBottom: 9 },
        sizeLarge: { minHeight: 52, paddingTop: 11, paddingBottom: 11 }
      }
    },
    MuiChip: {
      styleOverrides: { root: { fontWeight: 600 } }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head": {
            backgroundColor: "#F7F5F0",
            fontWeight: 700,
            color: "#374151",
            fontSize: "0.78rem",
            textTransform: "uppercase",
            letterSpacing: "0.04em"
          }
        }
      }
    }
  }
});

export { SIDEBAR_BG, PRIMARY };
